import axios from 'axios';
import DemoFileUpload from 'components/orderdetail/DemoFileUpload';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Col, Dropdown, Form, InputGroup, Modal, Row, Button, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
const DiscontinuePrescriptionModal = ({ show, setShow }) => {
  const location = useLocation();
  const state = location?.state?.original;
  const prescriptionId = state?.orderid;
  const [selectedDrugs, setSelectedDrugs] = useState([{
    "name": state?.drug,
    "rxNumber": state?.pharmacy_order_id,
    "qty": parseFloat(state?.qty)
  }]);
  const [note, setNote] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  let initalData = {
    patient_id: state?.patientid,
    order_type: "5",
    note: '',
    prescriptions: [],
    is_createOrder: state?.from_ips == 0 ? false : true,
  };
  const [formData, setFormData] = useState(initalData);

  const validateForm = () => {
    let newErrors = {};

    const hasNote = note.trim() !== "";
    const hasDocument = uploadedFile && uploadedFile.length > 0;
    
    if (formData.is_createOrder && !hasDocument) {
      newErrors.uploadedFile = "Please upload a document.";
    } else if (!formData.is_createOrder && !hasNote) {
      newErrors.note = "Please enter a note.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  async function handleSubmit(e) {
    e.preventDefault();

    if (!validateForm()) return;
    setLoading(true);
    const payload = {
      create_order: formData.is_createOrder ? 1 : 0,
      patient_id: formData.patient_id,
      order_type: '5',
      note: note,
      delivery_date: moment().add(1, 'days').format('MM/DD/YYYY'),
    };
    const prescriptions = selectedDrugs.map((drug) => ({
      rx_number: drug.rxNumber,
      quantity: drug.qty,
    }));
    payload.prescriptions = JSON.stringify(prescriptions);

    const payloadData = {
      id: prescriptionId,
      note: note,
    }

    const submissionData = new FormData();
    Object.keys(payload).forEach((key) => {
      submissionData.append(key, payload[key]);
    });

    if (uploadedFile && uploadedFile.length > 0) {
      uploadedFile.forEach((file) => {
        submissionData.append("documents", file, file.name);
      });
    }

    const finalPyload = formData.is_createOrder ? submissionData : payloadData;

    try {
      const tokenStr = localStorage.getItem("accessToken");

      const pelmedsPrescriptionUrl = formData.is_createOrder ? `${process.env.REACT_APP_SERVER_URL}/orders/create-prescription-order/` : `${process.env.REACT_APP_SERVER_URL}/prescriptions/discontinue-prescription`;

      const { data } = await axios.post(pelmedsPrescriptionUrl, finalPyload, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });

      if (data.status) {
        toast.success("Prescription Order added successfully");
        resetForm();
        window.location.reload(true)
      } else {
        toast.info("Error occurred while adding/updating Prescription Order.");
        setLoading(false);
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }


  const handleFileChange = (files) => {
    setUploadedFile(files);
  };

  const resetForm = () => {
    setSelectedDrugs([]);
    setNote("");
    setFormData(initalData);
    setShow(false);
    setLoading(false);
  };
  return (
    <Modal onHide={resetForm} show={show} size="lg">
      <Modal.Header closeButton>
        <Modal.Title as="h5">Discontinue Order for {state?.individual}/{state?.facilityname}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-body-tertiary p-4">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col>
              <Form.Check
                type='switch'
                name="is_createOrder"
                id='is_createOrder'
                className="fs-5"
                checked={
                  formData.is_createOrder
                }
                disabled={state?.from_ips == 0 ? true : false}
                onChange={e =>
                  setFormData({
                    ...formData,
                    is_createOrder: e.target.checked
                  })
                }
                label='Create a DC order in Pharmacy'
              />
            </Col>
          </Row>
          {(
            <>
              {selectedDrugs.length > 0 && (
                <>
                  <Row className="mt-4">
                    <Col xs={5} sm={6} md={6}>
                      <Form.Label>Drug Name</Form.Label>
                    </Col>
                    <Col xs={3} sm={2} md={2}>
                      <Form.Label>Rx Number</Form.Label>
                    </Col>
                    <Col xs={3} sm={3} md={3}>
                      <Form.Label>Qty</Form.Label>
                    </Col>
                    <Col>
                      {/* <Form.Label>Remove</Form.Label> */}
                    </Col>
                  </Row>

                  {selectedDrugs.map((drug, index) => (
                    <Row key={index} className="mb-3 align-items-center">
                      <Col xs={5} sm={6} md={6}>
                        <Form.Control type="text" value={drug.name} readOnly />
                      </Col>
                      <Col xs={3} sm={2} md={2}>
                        <Form.Control type="text" value={drug.rxNumber} readOnly />
                      </Col>
                      <Col xs={3} sm={3} md={3}>
                        <Form.Control
                          type="number"
                          min="1"
                          value={drug.qty}
                          placeholder="Enter Qty"
                          readOnly
                        />
                      </Col>
                    </Row>
                  ))}
                </>
              )}
            </>
          )}
          {(
            <Row>
              <Col>
                <Form.Label>
                  Upload Document
                </Form.Label>
                <DemoFileUpload
                  onFilesChange={handleFileChange}
                  textOfDoc={'Document Upload'}
                  errorFlag={!!errors.uploadedFile}
                />
                {errors.uploadedFile && <small className="text-danger">{errors.uploadedFile}</small>}
              </Col>
            </Row>
          )}
          {(
            <Row>
              <Col>
                <Form.Label>Notes</Form.Label>
                <Form.Control as="textarea" rows={1} value={note} onChange={(e) => setNote(e.target.value)} />
                {errors.note && <small className="text-danger">{errors.note}</small>}
              </Col>
            </Row>
          )}
          <Row className="mb-3">
            <Col md={12}>
              <Form.Label className="text-danger text-center fw-bold">
                *Please call pharmacy for urgent or after hours deliveries.
              </Form.Label>
            </Col>
          </Row>
          <Row className='d-flex justify-content-center'>
            <Button type="submit"
              color="primary"
              name="addordermodalsubmit"
              className='w-25'
              disabled={loading}>
              {loading ? <Spinner size="sm" animation="border" /> : "Submit"}
            </Button>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default DiscontinuePrescriptionModal;
